import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PaginatePipe } from 'src/app/pipes/paginate.pipe';
import { PipeModule } from 'src/app/pipes/pipe-module';
import { AdminMantenimientoMembresiasBackview } from './admin-mantenimiento-membresias.component.backview';
import { NgxSpinnerModule } from "ngx-spinner";
import { MatMenuModule } from '@angular/material/menu';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';

@NgModule({
  declarations: [AdminMantenimientoMembresiasBackview
  ],
  imports: [
    CommonModule,
    FormsModule,
    HeaderModule,
    FooterModule,
    MatPaginatorModule,
    PipeModule,
    NgxSpinnerModule,
    MatMenuModule
  ],
  exports: [
    AdminMantenimientoMembresiasBackview]
})
export class AdminMantenimientoMembresiasModule { }
